import { render } from "./BottomNavigationBar.vue?vue&type=template&id=1cc6ee99&scoped=true"
const script = {}

import "./BottomNavigationBar.vue?vue&type=style&index=0&id=1cc6ee99&scoped=true&lang=css"

import exportComponent from "C:\\Users\\TOP\\Desktop\\vue\\nomad-poc-new\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1cc6ee99"]])

export default __exports__